export default __webpack_public_path__ + "media/images/images/elements/apple-watch-4e1e551cc63805cc9e40aa73d86e75f7.png";